import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Radio, Col, Row } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const MultipleSignModal = ({
  openSignModal,
  setOpenSignModal,
  signContract,
  form,
  contract
}) => {
  const { t } = useTranslation();

  const Amendments = () => {
    const result = [];
    for (let i = 0; i < contract?.amendment?.length; i += 1) {
      if (
        !contract?.amendment[i].contract_signed &&
        contract?.amendment[i].status === 'ACTIVE'
      ) {
        result.unshift(
          <Col span={24}>
            <Radio value={`amendment_${i}`}>
              {`${t('contracts.form.print_amendment')} ${i + 1}`}
            </Radio>
          </Col>
        );
      }
    }
    return result.map((i) => i);
  };

  return (
    <>
      <Modal
        title={t(`contracts.modal.title_sign`)}
        centered
        style={{ top: 20 }}
        open={openSignModal}
        onCancel={() => {
          setOpenSignModal(false);
          form.resetFields();
        }}
        width={550}
        footer={[
          <div style={{ textAlign: 'center', fontWeight: 700 }}>
            {!contract?.universign_url ? (
              <Button
                onClick={() => signContract(null, null, true)}
                type="primary"
                style={{
                  width: 'auto',
                  padding: '4px 15px'
                }}
              >
                {t('buttons.validate_sign')}
              </Button>
            ) : (
              <a
                target="_blank"
                href={`${contract?.universign_url}`}
                rel="noopener noreferrer"
                style={{ flexDirection: 'column' }}
              >
                <div>
                  <Button
                    type="primary"
                    style={{
                      width: 'auto',
                      padding: '4px 15px'
                    }}
                  >
                    <LinkOutlined />
                    Lien vers universign
                  </Button>
                </div>
              </a>
            )}
          </div>
        ]}
      >
        <Form form={form}>
          <Form.Item name="documents">
            <Radio.Group>
              <Row>
                {contract && contract?.amendment ? <Amendments /> : <></>}
                {!contract?.contract_signed && contract.status === 'ACTIVE' && (
                  <Col span={24}>
                    <Radio value="contract">
                      {t('contracts.form.print_contract')}
                    </Radio>
                  </Col>
                )}
              </Row>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

MultipleSignModal.propTypes = {
  openSignModal: PropTypes.bool.isRequired,
  setOpenSignModal: PropTypes.func.isRequired,
  signContract: PropTypes.func.isRequired,
  contract: PropTypes.shape({
    amendment: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.string,
    payment_type: PropTypes.string,
    contract_signed: PropTypes.bool,
    universign_url: PropTypes.string
  }).isRequired,
  form: PropTypes.shape({
    resetFields: PropTypes.func
  }).isRequired
};

export default MultipleSignModal;
